const getToken = () => {
  return localStorage.getItem('auth');
};

export default getToken;



// WEBPACK FOOTER //
// ./src/components/Pages/GetToken/GetToken.js